import {
  Div,
  Flex,
  LoadingSpinner,
  Text,
} from '@sendoutcards/quantum-design-ui'
import React, { FC } from 'react'
import ReferralCreditsCard from '../ReferralCreditsCard/ReferralCreditsCard'
import { useCreditsBalance } from 'src/react_query'
import { Currency } from 'src/graphql/generated/graphql'

const CreditsUnavailable: FC = () => (
  <Text type="caption" color="danger">
    Your credits balance is unavailable at the moment, try again later.
  </Text>
)

const ReferralCreditsLine: FC = () => {
  const creditsBalance = useCreditsBalance()

  if (creditsBalance.isLoading) {
    return <LoadingSpinner size="medium" />
  }

  const isUnavailable =
    creditsBalance.error !== null ||
    creditsBalance.data === undefined ||
    creditsBalance.data.currency === Currency.Unavailable

  return creditsBalance.data ? (
    <Flex
      width="100%"
      alignItems="center"
      inset={{ horizontal: 'x2', vertical: 'x1_5' }}
      outset={{ top: 'x1', bottom: 'x2' }}
      style={{ backgroundColor: '#eef0f2', borderRadius: 16 }}
    >
      <ReferralCreditsCard
        width="75px"
        height="42px"
        creditsBalance={creditsBalance.data}
      />
      <Div outset={{ left: 'x2' }}>
        {isUnavailable ? (
          <CreditsUnavailable />
        ) : (
          <Text
            weight="semiBold"
            type="caption"
            content={`Credits: ${creditsBalance.data?.description ?? '$0.00'}`}
          />
        )}
      </Div>
    </Flex>
  ) : (
    <></>
  )
}

// TODO: get designs and figure how to show referral credits details

// const ReferralCreditsDetails: FC = () => {
//   const detailedCredits = useDetailedReferralCredits()

//   if (detailedCredits.isLoading) {
//     return <LoadingSpinner size="small" />
//   }

//   const accordionSections =
//     detailedCredits.data && detailedCredits.data?.length > 0
//       ? [
//           {
//             key: 1,
//             heading: <Text weight="bold" type="caption" content={'Details'} />,
//             body: (
//               <VStack gap={'x1'} inset={'x0'}>
//                 {detailedCredits.data?.map(detail => (
//                   <div key={detail.id}>
//                     <HStack justify="space-between" gap={'x1'} inset={'x0'}>
//                       <Text type="body" weight="bold" color="primaryHeading">
//                         {detail.amount.description}
//                       </Text>
//                       <HStack justify="flex-end" gap="x_5" shouldWrap={true}>
//                         <Text type="body">Expires on</Text>
//                         <Text type="body" weight="bold" color="primaryHeading">
//                           {detail.expirationDate}
//                         </Text>
//                       </HStack>
//                     </HStack>
//                   </div>
//                 ))}
//               </VStack>
//             ),
//           },
//         ]
//       : null

//   return (
//         accordionSections && (
//           <div css={{ width: '100%' }}>
//             <Accordion inset="x0" sections={accordionSections} />
//           </div>
//         )
//   )
// }

export default ReferralCreditsLine
